export default "__VITE_ASSET__6bc14c38__"